import { render, staticRenderFns } from "./Prospecto.vue?vue&type=template&id=090e528c"
import script from "./Prospecto.vue?vue&type=script&lang=js"
export * from "./Prospecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports